import React, { useState, useRef } from 'react'
import * as S from './style'

interface CodeInputProps {
  onChange: (code: string) => void
  qtd?: string[]
}

const CodeInput: React.FC<CodeInputProps> = ({
  onChange,
  qtd = ['', '', '', ''],
}) => {
  const [values, setValues] = useState<string[]>(qtd)

  const inputRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ]

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newValue = e.target.value

    if (/^\d{0,1}$/.test(newValue)) {
      const newValues = [...values]
      newValues[index] = newValue
      setValues(newValues)

      if (newValue !== '' && inputRefs[index + 1]) {
        inputRefs[index + 1].current?.focus()
      }

      onChange(newValues.join(''))
    }
  }

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === 'Backspace' && values[index] === '') {
      if (index > 0) {
        const newValues = [...values]
        newValues[index - 1] = ''
        setValues(newValues)
        inputRefs[index - 1].current?.focus()
        onChange(newValues.join(''))
      }
    }
  }

  return (
    <S.Container>
      {values.map((value, index) => (
        <S.Code
          key={index}
          ref={inputRefs[index]}
          type="text"
          value={value}
          maxLength={1}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </S.Container>
  )
}

export default CodeInput
